import { createPlugin, createRoutableExtension } from '@backstage/core-plugin-api'
import { rootRouteRef } from './routes'

export const tasksObservabilityPlugin = createPlugin({
  id: 'tasks-observability',
  routes: {
    root: rootRouteRef
  }
})

export const TasksObservabilityPage = tasksObservabilityPlugin.provide(
  createRoutableExtension({
    name: 'TasksObservabilityPage',
    component: () => import('./Router').then(m => m.TasksObservabilityRouter),
    mountPoint: rootRouteRef
  })
)
